import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import { Unauthorized, AccessDenied } from '../constants/responseStatus'
import qs from 'query-string'
const service = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  paramsSerializer: (params) => {
    return qs.stringify(params, {arrayFormat: 'comma'})
  },
  timeout: 1000 * 60, // 1 minute
})

service.interceptors.request.use(
  config => {
    if (store.getters.accessToken) {
      config.headers['authorization'] = getToken()
      // config.headers['authorization'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

service.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    if (error?.response?.status == Unauthorized) {
      store.dispatch('auth/logout').finally(() => {
        Message({
          message: 'Vui lòng đăng nhập trước!',
          type: 'warning',
          duration: 5 * 1000,
        })
        router.push(`/login?redirect=${router.currentRoute.fullPath}`)
      })
    }
    if (error?.response?.status == AccessDenied) {
      Message({
        message: 'Không có quyền sử dụng chức năng này!',
        type: 'warning',
        duration: 5 * 1000,
      })
      router.push('/dashboard')
    }
    return Promise.reject(new Error(error?.response?.data?.message || error?.message || 'Error'))
  },
)

export default service
